import { Vector3Tuple } from "three";
import { create } from "zustand";

/** The coordinate systems the capture coordinates can be shown in */
export type CoordinateMode = "project" | "realWorld";

/** Easting, northing and height of the project origin, mocked */
const MOCK_ORIGIN_EASTING = 364_993.958;
const MOCK_ORIGIN_NORTHING = 5_865_000.978;
const MOCK_ORIGIN_HEIGHT = 325.005;

/**
 * Real-world coordinate system of the project.
 * MOCK for the prototype: the project data has no coordinate system nor project-to-world offset yet.
 */
export const MOCK_PROJECT_CRS = {
  name: "WGS 84 / UTM 32N",
  heightType: "ellipsoidal",
  /** Easting, northing and height of the project origin */
  origin: [
    MOCK_ORIGIN_EASTING,
    MOCK_ORIGIN_NORTHING,
    MOCK_ORIGIN_HEIGHT,
  ] satisfies Vector3Tuple,
};

/**
 * @param point A position in the project (y-up)
 * @returns the position in the real-world coordinate system of the project, still y-up
 * so it can be formatted like the project coordinates
 */
export function toRealWorldPosition([x, y, z]: Vector3Tuple): Vector3Tuple {
  const [e, n, h] = MOCK_PROJECT_CRS.origin;
  return [x + e, y + h, z - n];
}

type CoordinateModeState = {
  /** The coordinate system chosen by the user */
  mode: CoordinateMode;
  /** Sets the coordinate system chosen by the user */
  setMode(mode: CoordinateMode): void;
};

/** Shares the chosen coordinate system between the capture previews of the tree and the views */
export const useCoordinateModeStore = create<CoordinateModeState>()((set) => ({
  mode: "project",
  setMode: (mode) => set({ mode }),
}));
